import apiClient from './apiClient';

// Function for making the login API call
export const login = async (credentials) => {
  try {
    const response = await apiClient.post('Account/login', credentials, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response.data && response.data.token) {
      localStorage.setItem('token', response.data.token); // Store token
  }
    return response.data; // Return the response data (e.g., token, user info)
  } catch (error) {
    //console.error('Login failed:', error);
    //throw error; // Re-throw error to handle in the component
    throw error.response?.data?.message || 'Login failed';
  }
};

// Function for fetching the user profile data
export const getProfile = async (userId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiClient.get(`Profile/Get${userId}`, {
      headers: {
          Authorization: `Bearer ${token}`
      }
  });
  return response.data; // Return the profile data (e.g., profileImage, additional info)
  } catch (error) {
    if (error.response && error.response.status === 404) {
        // Return a default profile object if the profile is not found
        console.warn('Profile not found for user ID:', userId);
        return null;
    }
    throw error; // Re-throw other errors
}
};
